<div class="curva-abc-venda-referencia-select input-group">
    <div class="input-group-prepend" *ngIf="isShowTitle">
        <span class="input-group-text">
            Referência
        </span>
    </div>
    <div class="dropdown">
        <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
            [disabled]="disabled">

            <span class="curva-abc-venda-referencia-select-label">
                <span *ngIf="referencia">
                    {{referencia.nome}}
                </span>
                <span *ngIf="!referencia">
                    {{nullLabelSelected}}
                </span>
            </span>
    
        </button>
        
        <div class="dropdown-menu-container">
            <div class="dropdown-menu">
                <div class="dropdown-menu-itens">
                    <ng-template [ngIf]="isShowNull">
    
                        <a class="dropdown-item" 
                            [class.dropdown-item-select]="!idReferencia"
                            (click)="select(null)">
                            {{nullLabel}}
                        </a>
                        <div class="dropdown-divider"></div>
                    </ng-template>
    
                    <a *ngFor="let referencia of referenciasOptions" 
                        class="dropdown-item"
                        [class.dropdown-item-select]="referencia.id == idReferencia"
                        (click)="select(referencia)">
                        {{referencia.nome}}
                    </a>
                </div>
            </div>        
        </div>
    </div>
</div>